import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getIbgeStatesSelector,
    getIbgeCitiesSelector,
    getIbgeCities,
    getIbgeStates,
    getIbgeCitiesLoadState,
    getIbgeStatesLoadState,
} from './ibge.state';

export const withIbge = connect(
    state => ({
        ibgeStates: getIbgeStatesSelector(state),
        ibgeStatesLoadState: getIbgeStatesLoadState(state),
        ibgeCities: getIbgeCitiesSelector(state),
        ibgeCitiesLoadState: getIbgeCitiesLoadState(state),
    }),
    dispatch => bindActionCreators({
        onGetIbgeCities: getIbgeCities,
        onGetIbgeStates: getIbgeStates,
    }, dispatch),
);
